import { initializeApp } from 'firebase/app';
import { getAuth, inMemoryPersistence, setPersistence, signInWithEmailAndPassword } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

let app = null;
let auth = null;
let appCheck = null;

export default {
    init: ({
        apiKey, appId, authDomain, projectId, recaptchaKey,
    }) => {
        app = app || initializeApp({
            apiKey, appId, authDomain, projectId,
        });
        auth = auth || getAuth(app);
        appCheck = appCheck || initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(recaptchaKey),
            isTokenAutoRefreshEnabled: true,
        });
    },
    login: async (email, password) => {
        await setPersistence(auth, inMemoryPersistence);

        return signInWithEmailAndPassword(auth, email, password);
    },
};
